import React, { useState } from 'react';
import 'rsuite/dist/rsuite-no-reset.min.css';

import { API_BASE_URL } from "./baseURL";
import moment from "moment/moment";
import { DateRangePicker } from "rsuite";

const CustomDashboard = () => {
    const [visitStat, setVisitStat] = useState(null);

    const [objDateRange, setObjDateRange] = useState({
        dateFrom: null,
        dateTo: null,
    });

    function fetchNotesForDateRange() {
        const dateFrom = objDateRange.dateFrom.toISOString().split('T')[0]
        const dateTo = objDateRange.dateTo.toISOString().split('T')[0]

        fetch(`${API_BASE_URL}/farmers/notes-date-range/${dateFrom}/${dateTo}/statistics`, {
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
            method: "POST",
        })
            .then((response) => response.json())
            .then((data) => setVisitStat(data));
    }

    const onChange = (dateRange) => {
        const dateFrom = moment(dateRange[0]).toDate();
        const dateTo = moment(dateRange[1]).toDate();

        setObjDateRange({
            dateFrom,
            dateTo
        })
    }

    return (
        <>
            <DateRangePicker style={{marginLeft: "20px"}} onChange={ onChange } />

            <button
                type="text"
                className="mb-4 p-2 border border-gray-300 rounded"
                onClick={()=> fetchNotesForDateRange()}
                style={{ backgroundColor: "green", color: "white", marginLeft: "20px", marginTop: "20px" }}> Statistik erstellen </button>

            { visitStat ? (
                <div style={{ margin: "20px 20px 20px 20px" }}>
                    <h3>Anzahl der Besuche</h3>
                    <table style={{ width: "25%" }}>
                        <thead>
                            <tr>
                                <th style={{width:"10%", paddingLeft: "20px"}}>AD</th>
                                <th style={{width:"25%"}}>Besuche</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                visitStat.map((visits, index) => (
                                <tr key={index}>
                                    <td style={{ paddingLeft: "20px"}}>{visits.username}</td>
                                    <td>{visits.totalVisitNumber}</td>
                                </tr>
                                ))
                            }
                        </tbody>
                    </table>

                    <br/>
                    <br/>
                    <h3>Betreuungsintensität</h3>

                    <table style={{ width: "50%" }}>
                        <thead>
                            <tr>
                                <th style={{width:"10%", paddingLeft: "20px"}}>AD</th>
                                <th style={{width:"25%"}}>Landwirt</th>
                                <th style={{width:"25%"}}>Besuche</th>
                            </tr>
                        </thead>
                        <tbody>
                           {
                               visitStat.map((user) => {
                                   const visits = Object.entries(user.visits);

                                   return visits.map(([key, value], index) => (
                                       <tr key={`${user.username}-${key}`} style={{border: "1px solid #ccc"}}>
                                           {index === 0 && (
                                               <td rowSpan={visits.length} style={{ paddingLeft: "20px" }}> {user.username} </td>
                                           )}
                                           <td>{key}</td>
                                           <td>{value}</td>
                                       </tr>
                                   ));
                               })
                           }
                        </tbody>
                    </table>

                </div>
            ) : null }
        </>
    );
}

export default CustomDashboard;
